import React, { Component } from 'react';
import Spinner from 'components/Spinner';
import MaterialTable from 'material-table';
import { EYE_ICON, TRASH_ICON, EDIT_ICON, FILE_ICON, CALENDER_ICON, AddCircleIcon } from 'assets/constants/Icons';
import { INTERVAL, TYPE_SUCCESS, TYPE_FAIL } from 'assets/constants/Constants';
import Form from '@rjsf/material-ui';
import validator from '@rjsf/validator-ajv6';
import ShowToast from 'components/ShowToast';
import moment from 'moment';
import { getStdProcessList, deleteStdProcess } from 'lib/axiosUtils';
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material';
import { hasPermission } from 'components/Permission';

export class StdProcessPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            viewform: false,
            formData: null,
            buttonText: 'Create Process',
            formList: [],
            mytheme: createTheme({}),
        };
    }

    async componentDidMount() {
        const formsData = await getStdProcessList({}, {});
        console.log('[StdProcessPage] componentDidMount formsData:', formsData);
        this.setState({
            formList: formsData.data.result,
            isLoading: false,
        });
    }

    formbuilderHandler = async (data) => {
        if (data) {
            this.props.history.push({
                pathname: '/create-std-process-page',
                state: data,
            });
        } else {
            this.props.history.push({
                pathname: '/create-std-process-page',
                state: null,
            });
        }
    };

    viewFormHandler = (data) => {
        this.setState({
            viewform: true,
            formData: data,
        });
    };

    handleDelete = async (data) => {
        if (window.confirm('Are you sure you want to delete this Process?')) {
            this.setState({ isLoading: true });
            try {
                let deleteResponse = await deleteStdProcess({}, {}, data.processId);
                const ok = (deleteResponse.statusCode || deleteResponse.status) === 204;
                if (ok) {
                    let fetchResponse = await getStdProcessList({}, {});
                    this.setState({
                        formList: fetchResponse.data.result,
                        isLoading: false,
                    });
                    ShowToast(
                        'Process deleted successfully',
                        TYPE_SUCCESS,
                        INTERVAL,
                        this.props,
                        ''
                    );
                } else {
                    this.setState({ isLoading: false });
                    ShowToast(
                        'Something went wrong. Please delete again after sometime!',
                        TYPE_FAIL,
                        INTERVAL,
                        this.props,
                        ''
                    );
                }
            } catch (error) {
                console.log('Error Occurred while deleting process', error);
                this.setState({ isLoading: false });
                ShowToast(
                    'Something went wrong. Please delete again after sometime!',
                    TYPE_FAIL,
                    INTERVAL,
                    this.props,
                    ''
                );
            }
        }
    };

    renderModalContent = () => {
        const { formData } = this.state;

        const isNewSchema =
            formData?.formSchema?.properties?.steps &&
            formData?.formSchema?.properties?.processTitle;

        if (isNewSchema) {
            const steps = formData.processSteps || [];
            return (
                <div>
                    <h3>{formData.formSchema.title || 'Process Details'}</h3>
                    <hr />
                    <h5 style={{ fontWeight: 'bold' }}>
                        {formData.formSchema.properties.processTitle.title || 'Process Title'}
                    </h5>
                    <p
                        style={{
                            fontSize: '1rem',
                            background: '#f8f9fa',
                            padding: '10px',
                            borderRadius: '4px',
                            border: '1px solid #dee2e6',
                        }}
                    >
                        {formData.processTitle}
                    </p>

                    {/* show duration */}
                    <div style={{ marginTop: 10, marginBottom: 10 }}>
                        <strong>Total Estimated Duration:</strong>{' '}
                        {Number.isFinite(formData.totalDuration)
                            ? `${formData.totalDuration} day(s)`
                            : '—'}
                    </div>

                    <h5 style={{ fontWeight: 'bold' }}>
                        {formData.formSchema.properties.steps.title || 'Steps'}
                    </h5>
                    <div
                        style={{
                            background: '#f8f9fa',
                            padding: '15px',
                            borderRadius: '4px',
                            border: '1px solid #dee2e6',
                        }}
                    >
                        {steps.length > 0 ? (
                            steps
                                .sort((a, b) => a.position - b.position)
                                .map((step, index) => (
                                <p key={index} style={{ margin: '2px 0', fontSize: '1rem' }}>
                                        {index + 1}. {step.step_title_snapshot}
                                        {step.duration_days > 0
                                            ? ` (${step.duration_days} day${
                                                step.duration_days !== 1 ? 's' : ''
                                            })`
                                            : ''}
                                </p>
                            ))
                        ) : (
                            <p>No steps defined.</p>
                        )}
                    </div>
                </div>
            );
        }

        return (
            <Form
                schema={formData.formSchema}
                uiSchema={formData.uiSchema || {}}
                validator={validator}
            >
                <></>
            </Form>
        );
    };

    render() {
        if (this.state.isLoading) {
            return <Spinner />;
        } else {
            return (
                <div className="main-content">
                    <div className="pagetitle row" style={{ color: 'black', paddingTop: 15, marginTop: '-25px' }}>
                        <div className="col-md-10 sm_device">
                            <i className={`${FILE_ICON}`}></i>
                            <span style={{ marginLeft: '7px', marginRight: '10px' }}>Standard Process List</span>
                            {hasPermission('customer', 'create') && (
                                <AddCircleIcon  
                                    onClick={() => this.formbuilderHandler(null)}
                                    style={{ 
                                        cursor: 'pointer', 
                                        color: '#1976d2', 
                                        fontSize: '30px !important',
                                    }}
                                    titleAccess="Add Standard Process"
                                />
                            )}
                        </div>
                        <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}>
                            <i className={`${CALENDER_ICON}`}></i> {moment().format('DD MMM YYYY')}
                        </div>
                    </div>
                    <div
                        style={{
                            borderBottom: '1px solid lightgray',
                            marginBottom: 15,
                            marginTop: 15,
                        }}
                    />
                    <div className="list-wrapper">
                        <div className="mt-4 border list-table-div" style={{ marginBottom: 50 }}>
                            {this.state.formList.length > 0 ? (
                                <ThemeProvider theme={this.state.mytheme}>
                                    <MaterialTable
                                        title=""
                                        columns={[  
                                            {
                                                title: 'Std. Process Name',
                                                field: 'processTitle',
                                                cellStyle: {
                                                    textAlign: 'center',
                                                },
                                                headerStyle: {
                                                    textAlign: 'center',
                                                },
                                                sorting: true,
                                            },
                                            {
                                                title: 'No. Of Steps',
                                                field: 'noOfSteps',
                                                type: 'numeric',
                                                cellStyle: {
                                                    textAlign: 'center',
                                                },
                                                headerStyle: {
                                                    textAlign: 'center',
                                                },
                                                sorting: false,
                                            },
                                            {
                                                title: 'Total Duration (days)',
                                                field: 'totalDuration',
                                                sorting: true,
                                                render: (rowData) =>
                                                    Number.isFinite(rowData.totalDuration)
                                                        ? `${rowData.totalDuration}`
                                                        : '—',
                                                cellStyle: {
                                                    textAlign: 'center',
                                                },
                                                headerStyle: {
                                                    textAlign: 'center',
                                                },
                                            },
                                        ]}
                                        data={this.state.formList.map((item, index) => ({
                                            serialNo: index + 1,
                                            processId: item._id,
                                            processTitle: item.process_title,
                                            noOfSteps: item.number_of_steps,
                                            totalDuration:
                                                typeof item.total_estimated_duration === 'number'
                                                    ? item.total_estimated_duration
                                                    : 0,
                                            formSchema: item.form_schema,
                                            uiSchema: item.ui_schema,
                                            processSteps: item.process_steps || [],
                                        }))}
                                        actions={[
                                            hasPermission('steps_page', 'read') && {
                                                icon: () => (
                                                    <i
                                                        className={`${EYE_ICON}`}
                                                        title="View Form"
                                                        style={{ textAlign: 'center' }}
                                                    ></i>
                                                ),
                                                onClick: (event, rowData) =>
                                                    this.viewFormHandler(rowData),
                                            },
                                            hasPermission('steps_page', 'update') && {
                                                icon: () => (
                                                    <i
                                                        className={`${EDIT_ICON}`}
                                                        title="Edit Form"
                                                        style={{ textAlign: 'center' }}
                                                    ></i>
                                                ),
                                                onClick: (event, rowData) =>
                                                    this.formbuilderHandler(rowData),
                                            },
                                            hasPermission('steps_page', 'delete') && {
                                                icon: () => (
                                                    <i
                                                        className={`${TRASH_ICON}`}
                                                        title="Delete Form"
                                                        style={{ textAlign: 'center' }}
                                                    ></i>
                                                ),
                                                onClick: (event, rowData) =>
                                                    this.handleDelete(rowData),
                                            },
                                        ]}
                                        options={{
                                            pageSize: 5,
                                            pageSizeOptions: [10, 20, 50],
                                            actionsColumnIndex: -1,
                                            headerStyle: {
                                                color: '#2d3d42',
                                                fontWeight: 'bolder',
                                                fontSize: 14,
                                                textAlign: 'center',
                                            },
                                            rowStyle: {
                                                textAlign: 'center',
                                            },
                                            filtering: false,
                                            sorting: true,
                                            columnsButton: true,
                                            exportButton: true,
                                            exportFileName: 'fb_forms',
                                            cellStyle: {
                                                color: '#2d3d42',
                                                fontSize: 12
                                            }
                                        }}
                                    />
                                </ThemeProvider>
                            ) : (
                                <div className="text-center pt-2">
                                    <label>Records not found!</label>
                                </div>
                            )}
                            {this.state.viewform && (
                                <div className="custom_modal">
                                    <div className="modal_body">
                                        <button
                                            type="button"
                                            style={{ fontSize: 25 }}
                                            className="close text-right"
                                            onClick={() => this.setState({ viewform: false })}
                                        >
                                            &times;
                                        </button>
                                        {this.renderModalContent()}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default StdProcessPage;
